module.exports = __webpack_public_path__ + "static/logo_pcc-cb2dfad60659b3ab816764b3e322500b.jpg";